module.exports = __webpack_public_path__ + "img/qrcode_image.ea212c05.png";